window.setupRecorder = function (beforeSend, afterSend, btnObj) {
    let btn = $(".idoc-main-search .btn-record-audio");
    if (btnObj) {
        btn = $(btnObj);
    }
    let mediaRecorder;
    let audioChunks = [];
    let stream;
    let recorderOn = false;
    //const maxRecordingTime = 60000; // 60000 milliseconds = 1 minute
    //30 seconds
    const maxRecordingTime = 30 * 1000; // 30000 milliseconds = 30 seconds

    //remove on click event
    const handler = async function (event) {
        if (recorderOn) {
            $(btn).find('i').removeClass('fa-stop').addClass('fa-microphone');
            $(btn).addClass('btn-outline-primary').removeClass('btn-outline-danger');
            mediaRecorder.stop();
            stream.getTracks().forEach(function (track) {track.stop()});
            recorderOn = false;
        } else {
            $(btn).find('i').removeClass('fa-microphone').addClass('fa-stop');
            $(btn).addClass('btn-outline-danger').removeClass('btn-outline-primary');
            stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            mediaRecorder = new MediaRecorder(stream);
            audioChunks = [];

            mediaRecorder.ondataavailable = function (event) {
                audioChunks.push(event.data);
            };

            mediaRecorder.onstop = function () {
                if (typeof beforeSend === "function") {
                    beforeSend();
                }
                const audioBlob = new Blob(audioChunks, { type: "audio/webm" });
                const formData = new FormData();
                formData.append("audio", audioBlob, "audio.webm");
                let idThread = $(event.target).closest('.btn-record-audio').data('id-thread') || 0;
                formData.append("idThread", idThread);

                // Invia il file al server
                httpRequest(api_url + 'ai/audio', formData, {contentType: false, processData: false, showLoader: (idThread ? false : true)}).then(onResult => {
                    if (!onResult.result) {
                        return showError(onResult.error);
                    }
                    if (! idThread) {
                        return location.href= base_url + 'ai/' + onResult.data.thread._id;
                    }

                    if (typeof beforeSend === "function") {
                        afterSend();
                    }
                }).catch(onError => {
                    showError(onError);
                });
            };

            mediaRecorder.start();
            recorderOn = true;
            
            setTimeout(() => {
                if (recorderOn) { // Check if recording is still on
                    $(btn).find('i').removeClass('fa-stop').addClass('fa-microphone');
                    $(btn).addClass('btn-outline-primary').removeClass('btn-outline-danger');
                    mediaRecorder.stop();
                    stream.getTracks().forEach(function (track) { track.stop(); });
                    recorderOn = false;
                }
            }, maxRecordingTime);
        }

    }
    $("body").off( "click", btn, handler )
    btn.on("click", handler);
};